<div class="main-div">
    <div class="row ms-0 me-0" id="lcl">
        <div class="col-xl-6 ps-0 pe-0 arrow-overlap-img">
            <img src="../assets/images/our-services/ocean-service/lcl.jpg" alt="LCL" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 bg-img-top">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">01.</span> Less than Container Load (LCL)</h2>
                <p class="font-16">Offering worldwide solutions with access to a comprehensive global network of guaranteed direct LCL services. With experience servicing several hundred tradelanes, we can provide a solution at competitive pricing with market leading transit
                    times from origin to destination on premium lines.
                </p>
            </div>
        </div>
    </div>

    <div class="row ms-0 me-0" id="fcl">
        <div class="col-xl-6 ps-0 pe-0 order-2 res-order-1 arrow-overlap-img-top">
            <img src="../assets/images/our-services/ocean-service/fcl.jpg" alt="FCL" class="img-fluid w-100">
        </div>
        <div class="col-xl-6 order-1 bg-img-bottom">
            <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                <h2 class="mb-3"><span class="number">02.</span> Full Container Load (FCL)</h2>
                <p class="font-16">With a global network of contracted FCL services and core carrier agreements with reputable global and local carries​, we offer multiple carrier options with differentiated and multi-tiered service levels​ as well as multi-modal solutions
                    including inland logistics.
                    <br><br> See your options with our <a href="javascript:void(0);" routerLink="/container-specification" class="more-link">Container Specifications</a> tool.</p>
            </div>
        </div>
    </div>
</div>


<section class="service-sub-full-bg" id="rail-transport">
    <div class="container-fluid">
        <div class="row ms-0 me-0">
            <div class="col-lg-6 order-1">
                <div class="ps-50 pe-50 pt-50 res-ps-15 res-pe-15">
                    <h2 class="mb-4 yellow-text"><span class="number">03.</span> Rail Transport</h2>
                    <p class="font-16 text-white">Consider rail transport to move your goods faster than ocean and cheaper than air​. We offer weekly LCL & FCL service from all major cities in China to Europe with fixed rates and door-delivery in Northern Europe​.
                        <br><br> For more information contact your <a href="javascript:void(0);" routerLink="/contact" class="more-link">local office</a></p>
                </div>
            </div>
        </div>
    </div>
</section>